"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectV2Theme = exports.selectBasicFontTheme = exports.optionFontTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _colors = require("../../../constants/colors");
const selectBasicFontTheme = {
  variant: {
    oldestar: {
      system: "lodestar",
      variant: "bodyText"
    },
    "lodestar-light": {
      system: "lodestar",
      variant: "bodyText"
    },
    "ursa-light": {
      system: "ursa",
      variant: "Inter--14px--400w"
    }
  }
};
exports.selectBasicFontTheme = selectBasicFontTheme;
const optionFontTheme = {
  variant: {
    oldestar: {
      system: "lodestar",
      variant: "bodyStrong"
    },
    "lodestar-light": {
      system: "lodestar",
      variant: "bodyStrong"
    },
    "ursa-light": {
      system: "ursa",
      variant: "Inter--14px--400w"
    }
  }
};
exports.optionFontTheme = optionFontTheme;
const selectV2Theme = (0, _sdsThemeInternal.themed)({
  padding: {
    "lodestar-light": "10px 8px",
    "ursa-light": "9px 8px"
  },
  border: {
    focusedRule: {
      "lodestar-light": "border",
      "ursa-light": "border-bottom"
    },
    focusedRadius: {
      "lodestar-light": _designTokens.border.radius10,
      "ursa-light": "0"
    },
    focusedInset: {
      "lodestar-light": "0px",
      "ursa-light": "1px"
    }
  },
  option: {
    backgroundColor: {
      hover: (0, _designTokensReact.color)("color--text--neutral-inverse--weak"),
      active: (0, _designTokensReact.color)("color--background--neutral--default")
    },
    noResults: {
      textAlign: {
        "lodestar-light": "center",
        "ursa-light": "inline-start"
      },
      fontSize: {
        "lodestar-light": "13px",
        "ursa-light": "14px"
      }
    }
  },
  actionButtons: {
    background: {
      hover: {
        // no semantic equivalent for buttonDefault
        "lodestar-light": _colors.buttonDefault,
        "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weaker")
      },
      active: (0, _designTokensReact.color)("color--background--neutral--default")
    },
    buttonWrapperSize: {
      "lodestar-light": "20px",
      "ursa-light": ""
    },
    gap: {
      "lodestar-light": "0px",
      "ursa-light": "4px"
    },
    size: {
      "lodestar-light": "32px",
      "ursa-light": "20px"
    },
    borderRadius: {
      "lodestar-light": "4px",
      "ursa-light": "6px"
    },
    margin: {
      top: {
        "lodestar-light": "4px",
        "ursa-light": "6px"
      },
      right: {
        "lodestar-light": "4px",
        "ursa-light": "6px"
      }
    }
  },
  autoSizeInput: {
    minHeight: {
      "lodestar-light": "28px",
      "ursa-light": "20px"
    },
    left: {
      "lodestar-light": "6px",
      "ursa-light": "2px"
    }
  },
  chip: {
    size: {
      "lodestar-light": "medium",
      "ursa-light": "xsmall"
    }
  },
  input: {
    padding: {
      left: {
        "lodestar-light": "12px",
        "ursa-light": "8px"
      },
      placeholder: {
        "lodestar-light": "40px",
        "ursa-light": "32px"
      }
    }
  },
  contentBefore: {
    width: {
      "lodestar-light": "40px",
      "ursa-light": "var(--smar--sds--content--before--width, 32px)"
    },
    flex: {
      "lodestar-light": "0 0 40px",
      "ursa-light": "var(--smar--sds--content--before--flex, 0 0 32px)"
    }
  }
});
exports.selectV2Theme = selectV2Theme;
//# sourceMappingURL=selectV2Theme.js.map